export default "__VITE_ASSET__C4V29G$6__"